import GlobalVariable from '@/global/global-variable'

// 检查ip是否连通
const checkIpConnect = GlobalVariable.BASE_PATH + "/common/checkIpConnect";

export default {
    checkIpConnect,
}



// WEBPACK FOOTER //
// ./src/request/api-common.js